import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExistingInsurance = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "existingInsurance",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12472",
			"data-name": "Path 12472",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12473",
			"data-name": "Path 12473",
			d: "M7,7h5.5",
			fill: "none",
			stroke: "#1c3d6c",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12474",
			"data-name": "Path 12474",
			d: "M7,11h3",
			fill: "none",
			stroke: "#1c3d6c",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12475",
			"data-name": "Path 12475",
			d: "M10,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H17a2,2,0,0,1,2,2V9",
			fill: "none",
			stroke: "#1c3d6c",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12476",
			"data-name": "Path 12476",
			d: "M12,14.031,16,12l4,2.031V17a4,4,0,0,1-8,0Z",
			fill: "none",
			stroke: "#1c3d6c",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgExistingInsurance;
